/**
 * Mini cart container inside the add ons popup
 *
 * @class MealPlanAddons
 * @typedef {MealPlanAddons}
 * @extends {HTMLElement}
 */
if (!customElements.get("meal-plan-addons")) {
  class MealPlanAddons extends HTMLElement {
    constructor() {
      super();

      const cta = this.querySelector("#meal-plan-cart-cta");

      if (cta) {
        cta.addEventListener("click", (e) => {
          e.preventDefault();
          document.querySelector("body").classList.add("locked");
          document.querySelector(".add-ons").classList.remove("closed");
        });
      }
    }
  }

  customElements.define("meal-plan-addons", MealPlanAddons);
}